import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { AppIframeTrackerModule } from '../../directives/app-iframe-tracker/app-iframe-tracker.module';
import { SanitizerUrlModule } from '../../pipes/sanitizer-url/sanitizer-url/sanitizer-url.module';

@Component({
    selector: 'app-iframe-handler',
    imports: [CommonModule, SanitizerUrlModule, AppIframeTrackerModule],
    templateUrl: './iframe-handler.component.html',
    styleUrls: ['./iframe-handler.component.scss']
})
export class IframeHandlerComponent {
  src = input<string>('')
}
